import React from 'react'

const MajorHat = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.19 15.37a2.16 2.16 0 00-.16-.51 3.758 3.758 0 010-.64v-2.79a8.36 8.36 0 00-5.11-7.56 9.518 9.518 0 00-1.5-.53 9 9 0 00-1.66-.27h-1.49a8.999 8.999 0 00-1.66.28 9.49 9.49 0 00-1.5.52A8.38 8.38 0 003 11.42v2.88c.012.16.012.32 0 .48a2.419 2.419 0 00-.2.59A2 2 0 004 17.73a21.79 21.79 0 008 1.65 21.24 21.24 0 008-1.65 2 2 0 001.19-2.36zm-16.7-3.94a6.77 6.77 0 013.6-5.87v3.62a.75.75 0 001.5 0V4.91a7.63 7.63 0 011.66-.33v6a.75.75 0 001.5 0v-6a7.08 7.08 0 011.66.33v4.27a.73.73 0 00.74.75.76.76 0 00.75-.75V5.55a6.78 6.78 0 013.61 5.87v2.14h-15l-.02-2.13zm7.7 6.46a18.818 18.818 0 007.22-1.54.61.61 0 00.31-.7c-.01-.06-.12-.59-.61-.59H4.82c-.49.01-.61.53-.61.59a.61.61 0 00.31.7 19 19 0 007.19 1.54h.48z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorHat
